import { useCallback, useMemo } from "react";
import { generateGuid } from "@entrilia/shared/utilities/generateGuid";
import type { MetricDescriptor, MetricsStructure } from "../../../../../../../../../api/types/svTypes.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch";
import { createUiSettingsAction } from "../../../../../store/utils/storeUtils";
import FieldItemContainer from "../FieldItem";
import FieldTreeAddButton from "../FieldTreeAddButton.tsx";
import { createMeasureTreeGroups } from "../fieldTree.ts";
import VirtualizedFieldTree from "../VirtualizedFieldTree.tsx";
import MetaFieldItem from "../MetaFieldItem.tsx";

interface Props {
  metrics: MetricDescriptor[];
  structure: MetricsStructure;
  disabled: boolean;
  expanded: boolean;
  visible: boolean;
}

const MetricsTree = ({ metrics, structure, disabled, expanded, visible }: Props) => {
  const dispatch = useAppDispatch();
  const handleDragStart = useCallback(() => {
    dispatch(createUiSettingsAction("setDragSessionId", generateGuid()));
  }, [dispatch]);
  const groups = useMemo(() => createMeasureTreeGroups(metrics, structure.groups), [metrics, structure]);
  const renderField = useCallback(
    (field: MetricDescriptor) => (
      <FieldItemContainer field={field} onDragStart={handleDragStart} disabled={disabled}>
        <MetaFieldItem field={field} actions={!disabled && <FieldTreeAddButton field={field} />} />
      </FieldItemContainer>
    ),
    [handleDragStart, disabled]
  );
  return (
    <VirtualizedFieldTree
      key={String(expanded)}
      groups={groups}
      defaultExpanded={expanded}
      visible={visible}
      renderField={renderField}
    />
  );
};

export default MetricsTree;
